import ProfilePanel from "./Pages/Profile";

export default [{ path: "/profile", element: <ProfilePanel /> }];
